module.exports = __webpack_public_path__ + "img/pescao_con_mixto_de_mariscos.bf611f18.jpg";